import React, { FunctionComponent } from 'react';
import { Maps } from '@doveit/lego';
import * as styles from './ListingLocation.style';

export interface ListingLocationProps {
  apiKey: string,
  route: string,
  suburb: string,
  normalizedAddress: string,
}

const ListingLocation: FunctionComponent<ListingLocationProps> = ({
  apiKey,
  route,
  suburb,
  normalizedAddress,
}) => (
  <div>
    <div css={styles.info}>
      <div>
        <strong>Indirizzo</strong>: {route}
      </div>
      {suburb && (
        <div>
          <strong>Quartiere</strong>: {suburb}
        </div>
      )}
    </div>
    <Maps
      apiKey={apiKey}
      title="Posizione immobile"
      params={normalizedAddress}
      width="100%"
      height="400px"
    />
  </div>
);

export default ListingLocation;
